// import type { TokensType } from '../theme/interface'

// export const varCreator = (TOKENS: TokensType) => {
//   return {
//     space_gap_vertical: TOKENS.space_2,
//     space_gap_horizontal: TOKENS.space_2,
//   }
// }

export const TODO = '暂时没有自定义变量'
